import React, { useState } from "react";
import {
  ColumnFiltersState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from "@tanstack/react-table";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { useInventory } from "./hooks";
import { InventoryItem } from "@/types/inventory";
import { useNavigate } from "react-router-dom";
import { getRoutes } from "@/utils/helpers";
// import { Input } from "../ui/input";

interface Props {
  data: InventoryItem[];
}

const Inventory: React.FC<Props> = ({ data: inventory }) => {
  const navigate = useNavigate();
  const routes = getRoutes();
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const { columns } = useInventory();

  const table = useReactTable({
    data: inventory,
    columns,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      columnFilters,
    },
  });

  return (
    <div className="w-full rounded-lg border border-gray-200 p-6">
      {/* <Input
        placeholder="Search..."
        value={(table.getColumn("inventory_title")?.getFilterValue() as string) ?? ""}
        onChange={(event) =>
          table.getColumn("inventory_title")?.setFilterValue(event.target.value)
        }
        className="max-w-xs"
      /> */}
      <Table>
        <TableHeader className="border-b border-slate-200">
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id} className="h-12">
              {headerGroup.headers.map((header) => (
                <TableHead key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </TableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row) => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
                className="h-12 cursor-pointer transition-colors duration-200 ease-in-out hover:bg-slate-100"
                onClick={() =>
                  navigate(
                    routes.inventoryDetails(row.original.inventory_item_id)
                  )
                }
              >
                {row.getVisibleCells().map((cell) => (
                  <TableCell
                    key={cell.id}
                    style={{
                      width: cell.column.getSize(),
                    }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="h-24 text-center">
                No results.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default Inventory;
